<template>
  <div
    class="dark border-b border-blue-900 from-blue-950 to-black text-white shadow-section-dark bg-gradient-to-b pt-8 pb-[4.5rem] -mb-16"
  >
    <s-page-block size="md" padding="horizontal">
      <div class="flex items-center justify-between flex-wrap-reverse gap-x-1 gap-y-2 mb-2">
        <s-link
          :href="route('blog.index')"
          class="whitespace-nowrap text-xl font-medium text-white/85 hover:text-white tracking-slight transition-all ease-out duration-100 flex items-center gap-2.5"
        >
          <s-logo icon class="h-10" />
          {{ t('page.overline') }}
        </s-link>
        <s-link
          :href="route('dashboard')"
          class="whitespace-nowrap underline underline-offset-2 decoration-transparent hover:decoration-blue-200/50 active:decoration-blue-300 decoration-2 font-medium text-blue-300 hover:text-blue-200 active:text-blue-400 tracking-slight transition-all ease-out duration-100 flex items-center gap-1.5"
        >
          <s-icon name="arrow-left" class="opacity-70" />
          {{ t('backToDashboard') }}
        </s-link>
      </div>
    </s-page-block>
  </div>
  <s-page-block size="md">
    <s-card padding="none" class="">
      <template #header>
        <div
          class="flex justify-between gap-1 items-start px-8 pt-6 pb-4 md:px-12 md:pt-8 md:pb-6 lg:px-14 lg:pt-8 lg:pb-6"
        >
          <div class="flex flex-col gap-2">
            <h1 class="grow text-5xl leading-tight flex items-center gap-2.5">
              {{ post.title }}
            </h1>
            <p
              v-if="post.publishedAt"
              class="flex items-center gap-1 text-lg text-gray-600 font-medium"
            >
              <s-icon name="calendar" class="opacity-70" />
              {{ monthDayYear(post.publishedAt) }}
            </p>
          </div>
          <s-badge v-if="!post.publishedAt" icon="pencil" size="lg">
            {{ t('status.draft') }}
          </s-badge>
        </div>
      </template>
      <template #content>
        <s-content class="px-8 py-6 md:px-12 md:py-8 lg:px-14 lg:py-10">
          <div v-html="post.content" />
        </s-content>
      </template>
    </s-card>
  </s-page-block>
</template>
<script setup lang="ts">
import SPageBlock from '../../design-system/SPageBlock.vue';
import SCard from '../../design-system/SCard.vue';
import SLink from '../../components/SLink.vue';
import SIcon from '../../design-system/SIcon.vue';
import SLogo from '../../design-system/SLogo.vue';
import PostData = App.DTOs.Blog.PostData;
import BlogLayout from '../../layouts/BlogLayout.vue';
import {monthDayYear} from '../../format/dates';
import SBadge from '../../design-system/SBadge.vue';
import {useI18n} from 'vue-i18n';
import {route} from 'ziggy-js';
import SContent from '../../design-system/SContent.vue';

defineProps<{
  post: PostData;
}>();

defineOptions({
  layout: BlogLayout,
});

const {t} = useI18n({
  useScope: 'local',
  inheritLocale: true,
});
</script>
<i18n>
{
  "en": {
    "page.overline": "Stemble Product Blog",
    "status.draft": "Draft",
    "backToDashboard": "Back to Dashboard"
  },
  "fr": {
    "page.overline": "Blog de produit de Stemble",
    "status.draft": "Brouillon",
    "backToDashboard": "Retour au tableau de bord"
  }
}
</i18n>
